import i18n from "@/i18n"

const tooltipText = () => ({
  'start-point': i18n.t('fleetTaskInstant.tooltip.point.start'),
  'end-point': i18n.t('fleetTaskInstant.tooltip.point.end'),
  'note-input': i18n.t('fleetTaskInstant.tooltip.note'),
  'late-notification-active-state': i18n.t('fleetTaskInstant.tooltip.lateNotification.active'),
  'late-notification-not-active-state': i18n.t('fleetTaskInstant.tooltip.lateNotification.inactive')
})

export default tooltipText
